import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Bot, ArrowRight } from 'lucide-react';
import { Button } from '../../components/common';

export const TransparencySection: React.FC = () => {
  return (
    <section className="py-16 bg-white dark:bg-slate-950 transition-colors">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="p-8 sm:p-12 rounded-3xl bg-gradient-to-br from-emerald-500/10 via-slate-50 to-slate-100 dark:from-emerald-950/30 dark:via-slate-900 dark:to-slate-900 border border-emerald-500/20 shadow-sm">
          <div className="w-12 h-12 rounded-2xl bg-emerald-600 text-white flex items-center justify-center mx-auto mb-4">
            <Bot className="w-6 h-6" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100 mb-3">
            Open, Honest, and Polite Crawler Architecture
          </h2>
          <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-400 max-w-2xl mx-auto mb-6 leading-relaxed">
            We identify ourselves with transparent User-Agent headers, respect merchant concurrency limits, and honor robots.txt directives. Retailers can inspect our crawler operating policy anytime.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/bot">
              <Button variant="outline" size="sm" className="gap-2">
                <ShieldCheck className="w-4 h-4 text-emerald-500" />
                <span>PriceLossBot Crawler Disclosure</span>
              </Button>
            </Link>

            <Link to="/abuse">
              <Button variant="ghost" size="sm" className="gap-2">
                <span>Store Delisting Portal</span>
                <ArrowRight className="w-3.5 h-3.5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
